export enum QueryOrigin {
  backFromSearch = 'back_from_search',
  backFromPDP = 'back_from_pdp',
  default = 'default',
  discoveryWall= 'discovery_wall',
  empathizeCategory = 'empathize_category',
  empathizeRecommendations = 'empathize_recommendations',
  empathizeReference = 'empathize_reference',
  empathizeTerm = 'empathize_term',
  emptySearch = 'empty_search',
  history = 'history',
  linked = 'linked',
  nextQueriesSuggestions = 'empathize_next_queries',
  nextQuery = 'next_query',
  nextQueryGrid = 'next_query_grid',
  noResults = 'no_results',
  partial = 'partial',
  popularSearches = 'empathize_trending',
  relatedTag = 'related_tag',
  spellCheck = 'spellcheck'
}
